import { useSearch } from "hooks/useSearch";
import React, { useState } from "react";
import { cn } from "utils/cn";
import { SEARCH, SEARCH_RHCOM } from "utils/constants";
import { usePageContent } from "customProviders/LocationProvider";
import SearchIcon from "@RHCommerceDev/icon-header-search";

const SearchField = () => {
  const { term, setTerm, executeSearch } = useSearch();
  const [isFocused, setIsFocused] = useState(false);
  const { pageContent } = usePageContent();

  return (
    <div
      className={cn(
        "flex items-center gap-1.5",
        "pl-[5px] pr-2.5",
        "h-[26px] w-[148px] md:w-[150px] lg:w-[196px]",
        "rounded-[52px] border-[0.5px] border-current"
      )}
    >
      <div>
        <SearchIcon className="h-[18.394px] w-[17.703px]" />
      </div>

      <input
        className={cn(
          "p-0 pt-[1px] text-inherit",
          "w-full bg-inherit outline-none",
          "font-rhc-roman font-normal tracking-[0.015em]",
          "text-[13px] leading-[1.5em] caret-inherit",
          "placeholder:font-thin placeholder:text-rh-warm-latte"
        )}
        value={term}
        onKeyDown={e => {
          if (e.key === "Enter") executeSearch();
        }}
        onChange={e => setTerm(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={isFocused ? SEARCH : ""}
        aria-label={pageContent?.globalHeader?.SEARCH_RHCOM ?? SEARCH_RHCOM}
      />
    </div>
  );
};

export default SearchField;
